import { render, staticRenderFns } from "./PostCreateEdit.vue?vue&type=template&id=ce7ce0aa&"
import script from "./PostCreateEdit.vue?vue&type=script&lang=js&"
export * from "./PostCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports